import React from "react";
import { useState , useRef , useEffect} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper';
import Footer from '../FooterFolder/Footer';
import AOS from "aos";
import 'aos/dist/aos.css';
import news from '../Images/news1.jpeg';
import news2 from '../Images/news2.jpeg';
import news3 from '../Images/news3.jpeg';
import news4 from '../Images/news4.jpeg';
import news5 from '../Images/news5.jpeg';
import news6 from '../Images/news6.jpeg';
import news7 from '../Images/news7.jpeg';
import news8 from '../Images/news8.jpeg';





export default function News() {

 /////////////////////////////////////////////////
  useEffect(() => {
    AOS.init({duration: 1500})
  
  }, [])
/////////////////////////////////////////////////
  const progressCircle = useRef(null);
  const progressContent = useRef(null);
  const onAutoplayTimeLeft = (s, time, progress) => {
    progressCircle.current.style.setProperty('--progress', 1 - progress);
    progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
  };

  const [showScroll, setShowScroll] = useState(false)

  const checkScrollTop = () => {    
   if (!showScroll && window.pageYOffset > 350){
      setShowScroll(true)    
   } else if (showScroll && window.pageYOffset <= 350){
      setShowScroll(false)    
   }  
};

  window.addEventListener('scroll', checkScrollTop)

  const ScrollArrow = () =>{
  const [showScroll, setShowScroll] = useState(false)

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 350){
      setShowScroll(true)
    } else if (showScroll && window.pageYOffset <= 350){
      setShowScroll(false)
    }
    }
  };  

  window.addEventListener('scroll', ScrollArrow)
  
  const scrollTop = () =>{
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  window.addEventListener('scroll', checkScrollTop)

 
  
  return (

    <>
    
<section className="row d-flex justify-content-center mt-5 pt-5">

    <div className="col-md-8 my-1">
    <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        onAutoplayTimeLeft={onAutoplayTimeLeft}
        className="mySwiper text-center "
      >
        <SwiperSlide><img src={news} alt="achegy"  className="img-fluid"/></SwiperSlide>
        <SwiperSlide><img src={news8} alt="achegy" className="img-fluid"/></SwiperSlide>
        <SwiperSlide><img src={news3} alt="achegy" className="img-fluid"/></SwiperSlide>
        <SwiperSlide><img src={news4} alt="achegy" className="img-fluid"/></SwiperSlide>
        <SwiperSlide><img src={news5} alt="achegy" className="img-fluid"/></SwiperSlide>
        <SwiperSlide><img src={news6} alt="achegy" className="img-fluid"/></SwiperSlide>
        <SwiperSlide><img src={news7} alt="achegy" className="img-fluid"/></SwiperSlide>
        <SwiperSlide><img src={news2} alt="achegy" className="img-fluid"/></SwiperSlide>

       
        <div className="autoplay-progress" slot="container-end">
          <svg viewBox="0 0 48 48" ref={progressCircle}>
            <circle cx="24" cy="24" r="20"></circle>
          </svg>
          <span ref={progressContent}></span>
        </div>
    </Swiper> 
    </div>
    


</section>
    <div className="container my-5">

        <p> We are pleased to announce the successful delivery of accreditation certificates from the Industrial Development Authority (IDA) to our certified offices.</p>
        <p>
            This milestone marks a significant step forward in enhancing our commitment to regulatory compliance and operational excellence. These certificates validate the readiness and professional standards of our offices in accordance with the latest guidelines issued by the IDA.

            Each accredited office has met the stringent criteria set by the authority, including technical qualifications, infrastructure adequacy, and adherence to best practices in service delivery. The distribution of these certificates reinforces our ongoing efforts to maintain transparency and build trust with our stakeholders.

            We extend our gratitude to the IDA for their cooperation and to our dedicated teams who worked diligently to meet all requirements. This achievement will enable our accredited offices to offer services more efficiently and confidently, contributing to the overall advancement of industrial development in the region.

            Stay tuned for further updates and insights as we continue to grow and innovate.</p>
    </div>
   
<Footer/>  
    </>
  )
}
